<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomer"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        ></Input>
        <DatePicker
          type="year"
          placement="bottom-end"
          placeholder="选择年份"
          style="width: 200px; margin-right: 30px"
          v-model="currentYear"
          @on-change="changeDate"
        />
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <!-- <span>共{{ totalRows }}条</span> -->
          <!-- <Page
            :total="totalRows"
            :page-size="limit"
            @on-change="loadDuiZhangDan"
            show-total
            simple
            style="min-width: 160px"
          /> -->
        </div>
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :columns="columns"
        :data="duizhangdan"
        :height="tableHeight"
        :loading="tableLoading"
        border
      >
      <!-- <template slot-scope="{ row }" slot="duiZhangDanCell">
        <Icon
          type="ios-remove-circle-outline"
          class="deleteBtn"
          @click="delPrice(row._id, 'transPrice')"
          size="23"
        />
      </template> -->
    </Table>
    </div>

    <DuiZhangDanDrawer
      ref="DuiZhangDanDrawerRef"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import DuiZhangDanDrawer from "./DuiZhangDanDrawer.vue";


export default {
  name: 'DuizhangdanPage',
  components: { DuiZhangDanDrawer },
  data() {
    return {
      tableHeight: 300,
      searchText: null,
      limit: 20,
      page: 0,
      filterQuery: {},
      tableLoading: false,
      columns: [
        {
          title: "归属公司",
          key: "company",
          fixed: "left",
          minWidth: 80,
          render: (h, params) => {
            return h(
              "span",
              params.row._id.company.abbr
            );
          },
        },
        {
          title: "责任人",
          key: "customer",
          fixed: "left",
          minWidth: 80,
          render: (h, params) => {
            return h(
              "span",
              "ss"
            );
          },
        },
        {
          title: "客户",
          key: "customer",
          fixed: "left",
          minWidth: 190,
          render: (h, params) => {
            return h(
              "span",
              params.row._id.customer.name
            );
          },
        },
        {
          title: "欠款金额",
          key: "receivable",
          align: "right",
          minWidth: 80,
          render: (h, params) => {
            return h(
              "span",
              Number(params.row?.totalAccountsReceivable).toLocaleString(
                    "zh",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )
                || "-"
              
            );
          },
        },
        
      ],
      currentYear: null,
    };
  },
  computed: mapState({
    duizhangdan: (state) => state.salesStat.duizhangdan,
  }),
  methods: {
    ...mapActions({
      getDuiZhangDan: "salesStat/getDuiZhangDanAction",
    }),
    async loadDuiZhangDan(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
        year: this.currentYear
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        await this.getDuiZhangDan(this.filterQuery)
        this.columns.splice(7, this.columns.length - 2);
        for (let i = 1; i <= 12; i++) {
          let date = {};
          date.key = `date${i}`;
          date.minWidth = 60;
          date.align = "right";
          date.renderHeader = (h, params) => {
            return h("div", `${i}`);
          };
          
          date.render = (h, params) => {
            if (dayjs().year(this.currentYear).month(i-1).isAfter(dayjs())) {
              return h("div", "-");
            }
            if (!params.row.arTable) {
              return h("div", {
                style: {
                  cursor: "pointer",
                  color: "lightgray",
                },
                on: {
                  click: () => {
                    this.$refs.DuiZhangDanDrawerRef.openDrawer(params.row._id.customer, this.currentYear, i);
                  }
                }
              }, "上传");
            }
          };
          this.columns.push(date);
        }
        this.tableLoading = false;
      } catch (error) {
        
      }
    },
    async searchCustomer() {},
    async changeDate(e) {
      if (e) {
        this.currentYear = e
      } else {
        this.currentYear = dayjs().format("YYYY");
      }
      this.loadDuiZhangDan();
    },
  },
  created() {
    this.currentYear = dayjs().format('YYYY')
    this.loadDuiZhangDan();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center
      min-width 220px

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>